import type { AuctionDetail, AuctionReport } from 'src/apis/monolith/types';
import { formatAuctionTimer, useTimer } from 'src/hooks/use-timer';

export function useAuctionCountdown(auction: AuctionDetail | AuctionReport) {
  // if we want "Publication in" in case of PREOPEN we would need useAuctionTimer(auctionTile.countDown.targetTime)
  // if we want "Starts in" in case of CLOSED (=Waiting for Next Round) we would need useAuctionTimer(auctionTile.countDown.targetTime)
  const timer = useTimer(
    auction.phase === 'PUBLISHED'
      ? auction.nextOpen
      : auction.phase === 'OPEN'
        ? auction.nextClose
        : undefined
  );

  const countdown = timer && <strong>{formatAuctionTimer(timer)}</strong>;
  const startCountdown = auction.phase === 'PUBLISHED' && countdown;
  const endCountdown =
    auction.phase === 'OPEN' && !auction.suspended && countdown;

  return startCountdown ? (
    <>Starts in {countdown}</>
  ) : endCountdown ? (
    <>Ends in {countdown}</>
  ) : undefined;
}
